import { createConfirmation } from "react-confirm";
import FormUiAddModal from "./FormUiAddModal";

export const showFormUiAddModal = createConfirmation(FormUiAddModal);
